import { useTranslation } from 'react-i18next';
import benefitsImage from 'assets/images/assist/less-work.jpg';
import { SURFACE_BLUE_SUBTLE } from '../../HostfullyAssist.styles';
import { BENEFIT_CARDS } from '../HostfullyAssistMarketing.constants';
import {
  CardGrid,
  CardsWithVisualRow,
  Overline,
  SectionBody,
  SectionHeader,
  SectionHeading,
  SectionInner,
  SideImage,
  SideVisual,
  WhiteSection,
} from '../HostfullyAssistMarketing.styles';
import MarketingContentCard from './MarketingContentCard';

const BenefitsSection = () => {
  const { t } = useTranslation();

  return (
    <WhiteSection data-testid="assist-benefits">
      <SectionInner>
        <SectionHeader $alignStart>
          <Overline>
            {t('pageHostfullyAssist.marketing.benefits.overline')}
          </Overline>
          <SectionHeading>
            {t('pageHostfullyAssist.marketing.benefits.headline')}
          </SectionHeading>
          <SectionBody>
            {t('pageHostfullyAssist.marketing.benefits.subheadline')}
          </SectionBody>
        </SectionHeader>
        <CardsWithVisualRow>
          <CardGrid $columns={2}>
            {BENEFIT_CARDS.map((card) => (
              <MarketingContentCard
                key={card.testId}
                card={card}
                background={SURFACE_BLUE_SUBTLE}
              />
            ))}
          </CardGrid>
          <SideVisual>
            <SideImage
              src={benefitsImage}
              alt={t('pageHostfullyAssist.marketing.benefits.imageAlt')}
            />
          </SideVisual>
        </CardsWithVisualRow>
      </SectionInner>
    </WhiteSection>
  );
};

export default BenefitsSection;
